/**
 * @file
 * Provide methods for collapsing elements.
 *
 * The trigger-element get the class 'js-collapse-trigger' and a data-target
 * attribute, which contains the data-target-id. The data-target-id is defined
 * as attribute on the element which should be collapsed.
 *
 * e.g. trigger-element
 * <span class="js-collapse-trigger" data-target="collapse">Ausklappen</span>
 *
 * e.g. collapsing-element
 * <div data-target-id="collapse">Lorem ipsum dolor sit amet</div>
 */

(function ($, Drupal) {
  Drupal.behaviors.collapseToggle = {
    attach: function attach(context) {
      once('awCollapseToggle', '.js-collapse-trigger', context).forEach(function(currentElement) {
        currentElement.addEventListener('click', function(event) {
          const $trigger = $(this);
          const $targetSelector = $trigger.data('target');
          const $target = $('[data-target-id="'+ $targetSelector +'"]');

          $('[data-target="'+ $targetSelector +'"]').each(function( index ) {
            $(this).toggleClass('is-active');
          });

          $target.slideToggle(200);
          event.preventDefault();
        })
      });
    }
  };
})(jQuery, Drupal);
